import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import Sidebar from '../../components/base/Sidebar/Sidebar';
import './Notifications.css';

function Notifications() {
  const navigate = useNavigate();
  const { user } = useApp();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleExamSubscriptionClick = () => {
    navigate('/exam-subscription');
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setLoading(true);
        const userID = user?.ID_usuario;
        
        // Build URL with userID if available
        let url = 'https://rvensino.com.br/get.php?action=notifications_dashboard';
        if (userID) {
          url += `&user_id=${userID}`;
        }
        
        const response = await fetch(url);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        console.log(data)
        
        // Filter only active notifications (active === 1)
        const activeNotifications = data.filter(notification => notification.active === 1);
        setNotifications(activeNotifications);
        setError(null);
      } catch (err) {
        console.error('Erro ao buscar notificações:', err);
        setError('Não foi possível carregar as notificações. Tente novamente mais tarde.');
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  // Function to decode Unicode escape sequences
  const decodeUnicode = (str) => {
    return str.replace(/\\u([\dA-F]{4})/gi, (match, grp) => {
      return String.fromCharCode(parseInt(grp, 16));
    });
  };

  // Function to render message with line breaks and links
  const renderMessage = (message) => {
    const decodedMessage = decodeUnicode(message);
    
    // Split by newlines and process each line
    return decodedMessage.split('\n').map((line, index) => {
      // First, check for quoted URLs (like "seulink.com.br")
      // This regex matches text in quotes that looks like a URL or domain
      const quotedUrlMatch = line.match(/"([^"\s]+(?:\.[^"\s]+)+)"/gi);
      
      if (quotedUrlMatch) {
        // Process each quoted URL found in the line
        let processedLine = line;
        const elements = [];
        
        quotedUrlMatch.forEach((quotedUrl) => {
          // Extract the URL from quotes
          const url = quotedUrl.slice(1, -1); // Remove quotes
          // Add https:// if not present
          const fullUrl = url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
          
          // Split the line at this quoted URL
          const parts = processedLine.split(quotedUrl);
          
          // Add text before the URL
          if (parts[0]) {
            elements.push(parts[0]);
          }
          
          // Add the link
          elements.push(
            <a key={`${index}-${url}`} href={fullUrl} target="_blank" rel="noopener noreferrer" className="notification-link-inline">
              {url}
            </a>
          );
          
          // Update processedLine to the remaining part
          processedLine = parts.slice(1).join(quotedUrl);
        });
        
        // Add any remaining text after the last URL
        if (processedLine) {
          elements.push(processedLine);
        }
        
        return <p key={index} className='notification-message'>{elements}</p>;
      }
      
      // Check if line contains a link pattern (text in quotes followed by URL pattern)
      const linkMatch = line.match(/"(.*?)"\s*:\s*(https?:\/\/[^\s]+)/);
      
      if (linkMatch) {
        const [, linkText, url] = linkMatch;
        return (
          <p key={index} className='notification-message'>
            {line.replace(/".*?"\s*:\s*https?:\/\/[^\s]+/, '')}
            <a href={url} target="_blank" rel="noopener noreferrer" className="notification-link-inline">
              {linkText}
            </a>
          </p>
        );
      }
      
      // Check if line contains a URL (with http:// or https://)
      const urlMatch = line.match(/(https?:\/\/[^\s]+)/g);
      if (urlMatch) {
        const parts = line.split(/(https?:\/\/[^\s]+)/g);
        return (
          <p key={index} className='notification-message'>
            {parts.map((part, i) => 
              urlMatch.includes(part) ? (
                <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="notification-link-inline">
                  {part}
                </a>
              ) : (
                part
              )
            )}
          </p>
        );
      }
      
      return <p key={index} className='notification-message'>{line}</p>;
    });
  };

  if (loading) {
    return (
      <div className='page-container'>
        <div className='menu'>
          <Sidebar />
        </div>
        <div className='content notifications-page'>
          <div className='notifications-container'>
            <h1 className='notifications-title'>Notificações</h1>
            <div className='loading-notifications'>
              <p>Carregando notificações...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='page-container'>
        <div className='menu'>
          <Sidebar />
        </div>
        <div className='content notifications-page'>
          <div className='notifications-container'>
            <h1 className='notifications-title'>Notificações</h1>
            <div className='error-notifications'>
              <p>{error}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='page-container'>
      <div className='menu'>
        <Sidebar />
      </div>
      <div className='content notifications-page'>
        <div className='notifications-container'>
          <h1 className='notifications-title'>Notificações</h1>
          
          {/* Special notification for exam subscription (always shown) */}
          {/* <div className='notification-card' onClick={handleExamSubscriptionClick}>
            <div className='notification-icon'>
              <span className='notification-badge'>📢</span>
            </div>
            <div className='notification-content'>
              <h2 className='notification-title'>Novo Simulado Disponível!</h2>
              <p className='notification-message'>
                Inscreva-se para o próximo simulado e teste seus conhecimentos.
              </p>
              <div className='notification-action'>
                <span className='notification-link'>Inscrever-se agora →</span>
              </div>
            </div>
          </div> */}

          {/* Dynamic notifications from API */}
          {notifications.length > 0 ? (
            notifications.map((notification) => (
              <div key={notification.id} className='notification-card'>
                <div className='notification-icon'>
                  <span className='notification-badge'>📢</span>
                </div>
                <div className='notification-content'>
                  <h2 className='notification-title'>{decodeUnicode(notification.title)}</h2>
                  {renderMessage(notification.message)}
                </div>
              </div>
            ))
          ) : (
            <div className='notifications-empty'>
              <p>Você está em dia! Não há outras notificações no momento.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Notifications;
